export default __webpack_public_path__ + "static/media/team_creative_avatar-01.b27c9124.png";